<ng-container *transloco="let t">
  @let stepperPosition = showStepper();
  <div class="sticky top-0 z-10 bg-white shadow-1">
    <div class="h-layout">
      <div class="flex h-19 items-center justify-between py-xs">
        @if (agencyLogo(); as logo) {
          <div class="relative h-[20px] w-auto min-w-[130px]">
            <img
              [ngSrc]="logo.url"
              [alt]="logo.title"
              class="object-contain object-left"
              content="logo"
              fill
              alt=""
              priority
            />
          </div>
        } @else {
          <a
            class="block cursor-pointer rounded-[100px] bg-grey-100 px-lg pt-sm pb-xs hover:bg-grey-300"
            [routerLink]="homePath"
          >
            <img ngSrc="assets/images/buildigo.svg" height="20" width="84" class="object-cover" alt="" />
          </a>
        }
        <div class="hidden w-full max-w-192 grow" [class.md:block]="stepperPosition === 'auto'">
          <cft-progress-stepper [activeStep]="activeStep()" [steps]="steps()" />
        </div>
        <div class="inline-flex flex-row justify-center gap-xs text-right">
          <ng-content select="action-pill" />
          <cft-icon-button
            iconSize="1x"
            bgIntensity="20"
            (click)="closed.emit(true)"
            [icon]="closeIcon"
            [ariaLabel]="t('createJobRequest.navbar.close')"
          />
        </div>
      </div>
    </div>
  </div>
  <div
    class="h-layout py-xl"
    [class.hidden]="stepperPosition === 'hidden'"
    [class.md:hidden]="stepperPosition === 'auto'"
  >
    <cft-progress-stepper [activeStep]="activeStep()" [steps]="steps()" />
  </div>
</ng-container>
